import axios from "axios";

export const fetchClubsData =
  (token, filter, userId, searchkey, yearData = {}, subFilterData = null) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_USER_OWN_CLUB_REQUEST" });
    const search = searchkey ? searchkey : "";

    let filter_sub = "";
    let filter_sub_c = "";
    if (subFilterData?.subFilter) {
      filter_sub = subFilterData.subFilter;
    }
    if (subFilterData?.childFilter) {
      filter_sub_c = subFilterData.childFilter;
    }

    try {
      let response;
      if (yearData?.year && yearData?.month) {
        response = await axios.get(
          `${process.env.REACT_APP_API_URL_USER}/clubs/getClubs/${userId}?filter=${filter}&search=${search}&year=${yearData?.year}&month=${yearData?.month}&filter_sub=${filter_sub}&filter_sub_c=${filter_sub_c}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
      } else {
        response = await axios.get(
          `${process.env.REACT_APP_API_URL_USER}/clubs/getClubs/${userId}?filter=${filter}&search=${search}&filter_sub=${filter_sub}&filter_sub_c=${filter_sub_c}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
      }
      if (searchkey) {
        if (response?.data?.success) {
          dispatch({
            type: "FETCH_USER_OWN_CLUB_SEARCH_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "FETCH_USER_OWN_CLUB_SEARCH_FAILURE",
            payload: response.data.message,
          });
        }
      } else {
        if (response?.data?.success) {
          dispatch({
            type: "FETCH_USER_OWN_CLUB_SUCCESS",
            payload: response.data,
          });
        } else {
          dispatch({
            type: "FETCH_USER_OWN_CLUB_FAILURE",
            payload: response.data.message,
          });
        }
      }
    } catch (error) {
      dispatch({
        type: "FETCH_USER_OWN_CLUB_FAILURE",
        payload: error.message,
      });
    }
  };
